import React, { useEffect } from 'react';
import { Box } from '@chakra-ui/react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { COMPONENT_MIN_HEIGHT } from '../../../../common/constants';
import { useSite } from '../../siteApi';
import { SubRouteTopNav } from '../SubRouteTopNav';
import { CircuitCardsListView } from './CircuitCardsListView';
import { MeterConfigurationChart } from './MeterConfigurationChart';
import { MeterConfigurationFilterInline } from './MeterConfigurationFilterInline';
import { resetMeterConfigurationState } from './meterConfigurationSlice';
import { SyncMeterState } from './SyncMeterState';

export function MeterSetupConfiguration() {
  const { site } = useSite();
  const siteId = site.clipsal_solar_id;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    // Reset the state when the component is unmounted
    return () => {
      dispatch(resetMeterConfigurationState());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box w="100%" minHeight={COMPONENT_MIN_HEIGHT} data-testid="meter-configuration-form">
      <SubRouteTopNav onGoBack={() => navigate(`/site/${siteId}/meter_setup/meters`)} title="Meter Configuration" />
      {/* This component is used to absorb re-renders as meter data is pulled every 5s */}
      <SyncMeterState />
      <MeterConfigurationChart />
      <MeterConfigurationFilterInline />
      <CircuitCardsListView />
    </Box>
  );
}
